import { Grid } from "components/grid/styles"
import Modal from "components/modal"
import remove from "icons/remove"
import styled from "styled-components"
import { maxWidth } from "utils"

export const CategoryModalContainer = styled.div`
  background-color: white;
  min-height: 80rem;
  width: 100%;

  ${maxWidth.mobile`
    padding: 0rem 1rem;
  `}
`

export const CategoryModalHeader = styled.div`
  width: 100%;
  height: 5rem;
  display: flex;
  justify-content: flex-end;
  padding: 2rem;
`

export const CategoryModalContent = styled.div`
  width: 100%;
`

export const CategoryModalFooter = styled.div`
  width: 100%;
  height: 5rem;
  display: flex;
  justify-content: center;
`

export const FooterClosePopUp = styled.p`
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
`

export const CustomizedModal = styled(Modal)`
  width: 80%;

  ${maxWidth.tablet`
    width: 100%;
  `}
`

export const FeaturedCardsGrid = styled(Grid)`
  padding: 2rem 4.8rem;
  background-color: #f6f6f6;
  margin: 0 4.8rem;

  ${maxWidth.tablet`
    padding: 1rem 2rem;
    margin: 0;
  `}
`

export const RemoveIcon = styled(remove)`
  cursor: pointer;
`

export const CategoryModalTitleContainer = styled.div`
  width: 100%;
  padding: 0 2rem;
  background-color: ${(props) => props.theme.colors.lightGray};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Abril, "Helvetica Neue", Helvetica, Arial, sans-serif;
`

export const CategoryModalTitle = styled.h2`
  font-size: 2.7rem;
  font-family: Abril;
  margin: 3rem 4rem;
  text-align: center;
  font-weight: 600;
`
